import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { Login } from "../../../helper/user/auth";
import { Navigate } from "react-router-dom";
import { LoggedInUser } from "../../../auth/appAuth";
import { ButtonSpinner } from "../../../components/spinners";
import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";

const LoginForm = () => {
  const initialvalue = {
    email: "",
    password: "",
    error: {
      email: "",
      password: "",
    },
    remember: false,
    isLoading: false,
  };

  const [login, setLogin] = useState(initialvalue);
  const [type, setType] = useState("password");

  let email = useRef();
  let password = useRef();

  const passwordVisible = (e) => {
    e.preventDefault();
    if (type === "password") {
      setType("text");
    } else {
      setType("password");
    }
  };

  const handleLogin = {
    getLogin: (e) => {
      setLogin({
        ...login,
        [e?.target?.name]: e?.target?.value,
      });
    },
    remember: (e) => {
      setLogin({
        ...login,
        [e?.target?.name]: e?.target?.checked,
      });
    },
    emailValidate: (email) => {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailPattern.test(email);
    },
    submitLogin: async () => {
      if (!login?.email) {
        setLogin({
          ...login,
          error: {
            email: "Enter email",
            password: "",
          },
        });
        email.current.focus();
      } else if (!handleLogin?.emailValidate(login?.email)) {
        setLogin({
          ...login,
          error: {
            email: "Enter a valid email",
            password: "",
          },
        });
        email.current.focus();
      } else if (!login?.password) {
        setLogin({
          ...login,
          error: {
            email: "",
            password: "Enter password",
          },
        });
        password.current.focus();
      } else {
        setLogin({
          ...login,
          error: {
            email: "",
            password: "",
          },
          isLoading: true,
        });
        let loginData = await Login(login);
        if (loginData?.status) {
          setLogin(initialvalue);
        } else {
          setLogin({
            ...login,
            error: {
              email: "",
              password: loginData?.message,
              isLoading: false,
            },
          });
        }
      }
    },
  };

  useEffect(() => {
    email.current.focus();
    setLogin({
      user: LoggedInUser(),
    });
  }, [LoggedInUser()]);

  return (
    <div>
      {login?.user && <Navigate to="/admin/dashboard" replace={true} />}
      <div className="mb-6">
        <label className="block text-gray-700 text-sm mb-3" htmlFor="email">
          E-mail
        </label>
        <input
          className={
            login?.error?.email
              ? "border-1 border-rose-600 hover:border-rose-600 appearance-none border rounded w-full px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm py-3"
              : "appearance-none border rounded w-full px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm py-3"
          }
          value={login?.email}
          ref={email}
          onChange={handleLogin?.getLogin}
          id="email"
          type="text"
          name="email"
          placeholder="mail@mail.com"
        />
        {login?.error?.email && (
          <p className="pt-2 text-red-600 text-sm">{login?.error?.email}</p>
        )}
      </div>
      <div className="mb-6">
        <label className="block text-gray-700 text-sm mb-3" htmlFor="password">
          Password
        </label>
        {/*    <input
          id="password"
          type="password"
          placeholder="Password"
          className={
            login?.error?.password
              ? "border-1 border-rose-600 hover:border-rose-600 appearance-none border rounded w-full px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm py-3 "
              : "appearance-none border rounded w-full px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm py-3"
          }
          ref={password}
          name="password"
          value={login?.password}
          onChange={handleLogin?.getLogin}
          onKeyPress={(e) => e?.key == "Enter" && handleLogin?.submitLogin()}
        />
        {login?.error?.password && (
          <p className="pt-2 text-red-600 text-sm">{login?.error?.password}</p>
        )} */}
        <div
          className={
            login?.error?.password
              ? "mt-3 flex justify-between items-center border rounded-md border-rose-600 hover:border-rose-600 focus:border-rose-600"
              : "border rounded-md mt-3 flex justify-between items-center"
          }
        >
          <input
            type={type}
            id="password"
            placeholder="Password"
            ref={password}
            className="appearance-none border-none rounded w-full px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-sm py-3  "
            name="password"
            value={login?.password}
            onChange={handleLogin?.getLogin}
            onKeyPress={(e) => e?.key == "Enter" && handleLogin?.submitLogin()}
          />
          <button className="mr-2" onClick={passwordVisible}>
            {type === "password" ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>
        {login?.error?.password && (
          <p className="pt-2 text-red-600 text-sm">{login?.error?.password}</p>
        )}
      </div>

      <div className="flex items-center justify-between mb-4">
        <div className="flex justify-start items-center">
          <input
            type="checkbox"
            id="rem"
            className="mr-2"
            name="remember"
            checked={login?.remember}
            onChange={handleLogin?.remember}
          />
          <label htmlFor="rem" className="text-sm">
            Remember me
          </label>
        </div>
        <Link
          className="inline-block align-baseline text-sm text-blue-500 hover:text-blue-800"
          to="/reset-password"
        >
          Forgot Password?
        </Link>
      </div>

      <div className="flex items-center justify-between">
        <button
          className={
            login?.isLoading
              ? "bg-blue-500 w-full text-white  mt-5 py-3 px-4 rounded opacity-50 cursor-not-allowed"
              : "btn-blue w-full mt-5 py-3 hover:bg-orange-600 text-white px-4 rounded focus:outline-none focus:shadow-outline"
          }
          onClick={handleLogin?.submitLogin}
        >
          {login?.isLoading ? <ButtonSpinner /> : "Sign In"}
        </button>
      </div>
    </div>
  );
};

export default LoginForm;
